export const CircleSideBar = ({ dashOffset }: { dashOffset: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      className="h-full w-full"
    >
      <path
        d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke="#D4D4D8"
        strokeWidth="3"
      />
      <g transform="rotate(90 18 18)">
        <path
          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none"
          stroke="#22C55E"
          strokeWidth="3"
          strokeDasharray="100"
          strokeDashoffset={dashOffset}
        />
      </g>
    </svg>
  );
};
